import { Outlet, Route, Routes } from "react-router-dom";
import App from "../../App";
import ConfidentialityPoliticsPage from "../../pages/ConfidentialityPoliticsPage";
import Error404 from "../../pages/ErrorPage";
import Friends from "../../pages/FriendsPage";
import LandingPage from "../../pages/LandingPage";
import ProfilePage from "../../pages/ProfilePage";
import SignAndLogPage from "../../pages/SignAndLogPage";
import RequireAuth from "../access/RequireAuth";
import RequireDisconnected from "../access/RequireDisconnected";
import Wishes from "../../pages/WishesPage";

const AppRoutes = () => {

    const UnprotectedPages = (
        <>
            <Route index element={<LandingPage />} />
            <Route path="login" element={<SignAndLogPage type="log" />} />
            <Route path="signup" element={<SignAndLogPage type="sign" />} />
            <Route path="dataProtectionDisconnected" element={<ConfidentialityPoliticsPage />} />
        </>
    );
    const RestrictedAccessPages = (
        <>
            <Route path="home" element={<LandingPage />} />
            <Route path="friends" element={<Friends />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="wishes" element={<Wishes />} />
            <Route path="dataProtectionLoggedIn" element={<ConfidentialityPoliticsPage />} />
        </>
    );

    return (
        <Routes>
            <Route path="/" element={<App />}>
                <Route
                    path="/"
                    element={
                        <RequireDisconnected>
                            <Outlet />
                        </RequireDisconnected>
                    }
                >
                    {UnprotectedPages}
                </Route>
                <Route
                    path="/"
                    element={
                        <RequireAuth>
                            <Outlet />
                        </RequireAuth>
                    }
                >
                    {RestrictedAccessPages}
                </Route>
                <Route path="*" element={<Error404 />} />
            </Route>
        </Routes>
    )
}

export default AppRoutes